import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { getRouteCnName } from '@/utils/route-metadata';
import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

export const useSiteRedirectTrack = (
  jumpCountryCode: string,
  fromTrigger: string,
  getPromptState: () => string,
) => {
  const pathname = usePathname();
  const { trackEvent } = useReporting();

  const SD_SwitchSitePopUp_Click = useCallback(
    (btn_name: string) => {
      try {
        const sdEventName = `SwitchSitePopUp_Click`;
        const sdEventParams = {
          page_name: getRouteCnName(pathname),
          url_path: window.location.href,
          notdisturb_prompt_state: getPromptState(),
          trigger_method: fromTrigger,
          target_site: jumpCountryCode?.toLowerCase(),
          btn_name,
        };
        trackEvent(
          {
            eventName: sdEventName,
            properties: sdEventParams,
          },
          [ProviderType.SENSORS],
        );
      } catch (e) {
        logger.info(e);
      }
    },
    [pathname, trackEvent, jumpCountryCode, fromTrigger, getPromptState],
  );

  const SD_SwitchSitePopUp_Exp = useCallback(() => {
    try {
      const sdEventName = `SwitchSitePopUp_Exp`;
      const sdEventParams = {
        page_name: getRouteCnName(pathname),
        url_path: window.location.href,
        notdisturb_prompt_state: getPromptState(),
        trigger_method: fromTrigger,
        target_site: jumpCountryCode?.toLowerCase(),
      };
      trackEvent(
        {
          eventName: sdEventName,
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.info(e);
    }
  }, [pathname, trackEvent, jumpCountryCode, fromTrigger, getPromptState]);

  return {
    SD_SwitchSitePopUp_Exp,
    SD_SwitchSitePopUp_Click,
  };
};
